module.exports = __webpack_public_path__ + "media/images/flags/1x1/nru-214020c8736b81b6e736ddac3926e996.svg";